var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "customer" },
    [
      _c("div", { ref: "contentTop" }, [
        _c("div", { staticClass: "tool" }, [
          _c("div", { staticClass: "customer-tool" }, [
            _c("div"),
            _c(
              "div",
              { staticStyle: { "line-height": "40px" } },
              [
                _c("AddEditDetail", {
                  ref: "drawer",
                  attrs: {
                    method: _vm.GetSearchList,
                    visible: _vm.showAddEditDetail
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.showAddEditDetail = $event
                    }
                  }
                }),
                _c(
                  "el-button",
                  {
                    staticClass: "hq-button",
                    attrs: { type: "primary", icon: "el-icon-folder-add" },
                    on: {
                      click: function($event) {
                        return _vm.openAddEditDetail("add")
                      }
                    }
                  },
                  [_vm._v("新增")]
                ),
                _c("Export", {
                  attrs: {
                    pageParam: _vm.pageParam,
                    total: _vm.total,
                    searchParam: _vm.exportParams
                  }
                }),
                _c("PositionProfile", {
                  attrs: { visible: _vm.showPositionProfileModal },
                  on: {
                    "update:visible": function($event) {
                      _vm.showPositionProfileModal = $event
                    }
                  }
                })
              ],
              1
            )
          ])
        ]),
        _c(
          "div",
          {
            staticStyle: { width: "94%", margin: "0 auto" },
            attrs: { gutter: 10 }
          },
          [
            _c("Search", {
              attrs: {
                searchAllParam: _vm.searchAllParam,
                searchParamList: _vm.searchParamList,
                code: "count"
              },
              on: { search: _vm.handleSearch, reset: _vm.reset }
            })
          ],
          1
        ),
        _c("div", { staticClass: "line" })
      ]),
      _c(
        "el-row",
        { staticStyle: { width: "94%", margin: "0 auto" } },
        [
          _c(
            "el-col",
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.listLoading,
                      expression: "listLoading"
                    }
                  ],
                  ref: "multipleTable",
                  staticStyle: { width: "100%" },
                  attrs: {
                    "highlight-current-row": "",
                    data: _vm.tableData,
                    "tooltip-effect": "dark",
                    border: "",
                    stripe: "",
                    size: "mini",
                    "element-loading-text": "拼命加载中",
                    "row-style": { height: "20px" },
                    "cell-style": { padding: "0px" },
                    "header-cell-style": { background: "#e5f2ff" }
                  },
                  on: { "row-click": _vm.clickRow }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": true,
                      fixed: "",
                      label: "审批编号",
                      prop: "id",
                      width: "170"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": true,
                      fixed: "",
                      label: "成交校区",
                      prop: "subscribeSchoolName",
                      width: "150"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": true,
                      fixed: "",
                      label: "校区属性",
                      prop: "schoolTypeName",
                      width: "80"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": true,
                      fixed: "",
                      label: "学员订单号",
                      prop: "orderNo",
                      width: "160"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": true,
                      label: "学员姓名",
                      prop: "studentName",
                      width: "80"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": true,
                      label: "报读商品",
                      prop: "goodsName",
                      width: "160"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": true,
                      label: "就业次数",
                      prop: "employmentNum",
                      width: "75"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": true,
                      label: "学员就业时间",
                      prop: "employmentTime",
                      width: "100"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": true,
                      label: "试用期月薪",
                      prop: "monthlyPay",
                      width: "90"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": true,
                      label: "就业老师",
                      prop: "employmentTeacher",
                      width: "100"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": true,
                      label: "是否转正",
                      prop: "pass",
                      width: "75"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": true,
                      label: "转正时间",
                      prop: "passTime",
                      width: "90"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": true,
                      label: "转正月薪",
                      prop: "passPay",
                      width: "75"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": true,
                      label: "面试职位",
                      prop: "interviewPosition",
                      width: "100"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": true,
                      label: "就业企业",
                      prop: "employmentCompany",
                      width: "150"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": true,
                      label: "备注",
                      prop: "remark",
                      width: "150"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": true,
                      label: "当前节点",
                      prop: "permission",
                      "min-width": "100"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": true,
                      label: "当前办理人",
                      prop: "approverName",
                      "min-width": "100"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": true,
                      label: "申请状态",
                      prop: "status",
                      "min-width": "120"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  scope.row.status == 5
                                    ? "审批中"
                                    : scope.row.status == 1
                                    ? "审批通过"
                                    : scope.row.status == 7
                                    ? "审批中"
                                    : scope.row.status == 2
                                    ? "审批拒绝"
                                    : scope.row.status == 3
                                    ? "审批撤销"
                                    : ""
                                ) +
                                " "
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": true,
                      label: "提交人",
                      prop: "submitName",
                      "min-width": "100"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": true,
                      label: "提交时间",
                      prop: "submitTime",
                      "min-width": "150"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(ref) {
                          var row = ref.row
                          return [
                            row.submitTime != "- -"
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatDate")(
                                        row.submitTime,
                                        "YYYY-MM-DD HH:mm:ss"
                                      )
                                    )
                                  )
                                ])
                              : _c("span", [_vm._v("- -")])
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "操作",
                      prop: "",
                      "min-width": "280",
                      fixed: "right"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function($event) {
                                    return _vm.openAddEditDetail(
                                      "detail",
                                      scope.row
                                    )
                                  }
                                }
                              },
                              [_vm._v("详情")]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function($event) {
                                    return _vm.changeJump(scope.row)
                                  }
                                }
                              },
                              [_vm._v("审核记录")]
                            ),
                            scope.row.makerId == _vm.myId
                              ? _c(
                                  "el-button",
                                  {
                                    staticClass: "hq-button",
                                    attrs: {
                                      type: "danger",
                                      disabled:
                                        scope.row.status == 1 ||
                                        scope.row.status == 5 ||
                                        scope.row.status == 7 ||
                                        scope.row.passType == "1"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.deleteClick(scope.row, 0)
                                      }
                                    }
                                  },
                                  [_vm._v("删除")]
                                )
                              : _vm._e(),
                            scope.row.makerId == _vm.myId
                              ? _c(
                                  "el-button",
                                  {
                                    staticClass: "hq-button",
                                    attrs: {
                                      type: "primary",
                                      disabled: _vm.isDisEdit(scope.row)
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.openAddEditDetail(
                                          "edit",
                                          scope.row
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v("编辑")]
                                )
                              : _vm._e(),
                            scope.row.makerId == _vm.myId
                              ? _c(
                                  "el-button",
                                  {
                                    staticClass: "hq-button",
                                    attrs: {
                                      type: "success",
                                      disabled:
                                        scope.row.status == 1 ||
                                        scope.row.status == 5 ||
                                        scope.row.status == 7
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.submitBtn(scope.row, 0)
                                      }
                                    }
                                  },
                                  [_vm._v("提交")]
                                )
                              : _vm._e(),
                            _vm.hasCheckPermission
                              ? _c(
                                  "el-button",
                                  {
                                    staticClass: "hq-button",
                                    attrs: {
                                      type: "primary",
                                      disabled:
                                        !scope.row.status ||
                                        scope.row.status == -1 ||
                                        scope.row.status == 1 ||
                                        scope.row.status == 2 ||
                                        scope.row.status == 3 ||
                                        !_vm.canPass(scope.row)
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.approvalShow(1, scope.row)
                                      }
                                    }
                                  },
                                  [_vm._v(" 通过 ")]
                                )
                              : _vm._e(),
                            _vm.hasCheckPermission
                              ? _c(
                                  "el-button",
                                  {
                                    staticClass: "hq-button",
                                    attrs: {
                                      type: "danger",
                                      disabled:
                                        !scope.row.status ||
                                        scope.row.status == -1 ||
                                        scope.row.status == 1 ||
                                        scope.row.status == 2 ||
                                        scope.row.status == 3 ||
                                        !_vm.canPass(scope.row)
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.approvalShow(2, scope.row)
                                      }
                                    }
                                  },
                                  [_vm._v(" 拒绝 ")]
                                )
                              : _vm._e(),
                            scope.row.makerId == _vm.myId
                              ? _c(
                                  "el-button",
                                  {
                                    staticClass: "hq-button",
                                    attrs: {
                                      disabled:
                                        !scope.row.status ||
                                        scope.row.status == -1 ||
                                        scope.row.status == 2 ||
                                        scope.row.status == 3 ||
                                        (!_vm.canRevoke(scope.row) &&
                                          scope.row.status == 1)
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.listBtn(3, scope.row)
                                      }
                                    }
                                  },
                                  [_vm._v(" 撤销 ")]
                                )
                              : _vm._e()
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "page_test_bottom" },
                [
                  _c("el-pagination", {
                    attrs: {
                      background: "",
                      layout: "total, sizes, prev, pager, next, jumper",
                      "current-page": _vm.pageParam.page,
                      "page-sizes": [10, 20, 50, 100],
                      "page-size": _vm.pageParam.limit,
                      total: _vm.total
                    },
                    on: {
                      "size-change": _vm.sizeChange,
                      "current-change": _vm.currentChange
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "HqModal",
        {
          attrs: {
            visible: _vm.approvalModel,
            title: "是否" + (_vm.operationType == 2 ? "拒绝" : "通过"),
            width: "400"
          },
          on: { "on-cancel": _vm.approvalCancel }
        },
        [
          _c(
            "el-form",
            { ref: "form", attrs: { model: _vm.form, rules: _vm.formRules } },
            [
              _c("div", [
                _vm._v(_vm._s(_vm.approvalStuName) + " 学员的就业申请")
              ]),
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c("div", { staticClass: "lineclass" }),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "changeReason" } },
                        [
                          _c("v-textarea", {
                            attrs: {
                              outlined: "",
                              "min-height": 80,
                              placeholder:
                                "请输入" +
                                (_vm.operationType == 2 ? "拒绝" : "通过") +
                                "理由，200字内",
                              name: "input-7-4",
                              label:
                                (_vm.operationType == 2 ? "拒绝" : "通过") +
                                "理由"
                            },
                            model: {
                              value: _vm.form.changeReason,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "changeReason", $$v)
                              },
                              expression: "form.changeReason"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c("el-button", { on: { click: _vm.approvalCancel } }, [
                _vm._v("取消")
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.approvalOk } },
                [_vm._v("确认")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("CheckHistory", {
        ref: "drawerCheck",
        attrs: {
          visible: _vm.onReviewHistoryStatus,
          reviewData: _vm.reviewData
        },
        on: { "on-cancel": _vm.onReviewHistoryCancel }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }